app.service('message', function (modal, broker, loading) {
	broker.on('403_ACCOUNT', function () { 
		function go() {
			modal.close();
			loading.redirect('/klient-ochrona-konta.bhtml');
		}
		alert('message-account-403-ltr', function () {
			go();
		});
		setTimeout(go, 4000);
	})
	function get(data) {
		if (!data) {
			reject();
		}
		if (typeof data === 'string') {
			data = {
				code: data
			}
		}
		return new Promise(function (resolve, reject) {
			$.ajax({
				url: '/message-alert.ltr',
				data: data,
				success: function (html) {
					resolve(html);
				},
				error: function () {
					modal.alert('Błąd pobierania komunikatu');
					reject();
				}
			});
		});
	}
	function alert(data, callback) {
		get(data).then(function (text) {
			modal.alert(text, callback);
		});
	}

	return {
		get, alert
	};
});
